import { ApiCall } from './ApiCall';

export class LoggerService {
  private static _enableLogging: boolean = false;

  public static enable(): void {
    LoggerService._enableLogging = true;
    console.log('[LoggerService] Logging enabled.');
  }

  public static disable(): void {
    LoggerService._enableLogging = false;
    console.log('[LoggerService] Logging disabled.');
  }

  public static log(...args: any[]): void {
    if (LoggerService._enableLogging) {
      console.log(...args);
    }
  }

  public static logMulti(...args: any[]): void {
    if (LoggerService._enableLogging) {
      console.log(...args);
      ApiCall.getInstance().AddLog(null, args);
    }
  }

  public static warn(...args: any[]): void {
    if (LoggerService._enableLogging) {
      console.warn(...args);
    }
  }

  public static error(...args: any[]): void {
    if (LoggerService._enableLogging) {
      console.error(...args);
    }
  }

  public static info(...args: any[]): void {
    if (LoggerService._enableLogging) {
      console.info(...args);
    }
  }
}
